import classNames from 'clsx';
import { ReactNode, memo } from 'react';

import * as styles from './Card.css';
import * as hoverStyles from './CardHover.css';
import { LinkArea } from '../LinkArea';
import { stopPropagation } from '../../utils/event';

export interface ICardProps {
  publisher: ReactNode;
  content: ReactNode;
  gallery: ReactNode;
  publicationDate: ReactNode;
  controls: React.ReactNode;
  href: string;
  isWide: boolean;

  onClick?: VoidFunction;
}

export function CardComponent({
  publisher,
  content,
  gallery,
  href,
  isWide,
  publicationDate,
  controls,
  onClick,
}: ICardProps) {
  return (
    <article className={classNames(styles['container'], hoverStyles['cont'])}>
      <div
        data-testid="offer-card"
        className={classNames(styles['card'], hoverStyles['card'], isWide && styles['wide'])}
      >
        <a className={styles['media']} href={href} target="_blank" rel="noreferrer" onClick={onClick}>
          {gallery}
        </a>
        <div className={styles['content']}>
          <div className={styles['general']}>
            <LinkArea className={styles['link']} href={href} target="_blank" onClick={onClick}>
              {content}
            </LinkArea>
          </div>
          <div className={styles['aside']}>
            <LinkArea className={styles['publisher-cont']} href={href} target="_blank" onClick={onClick}>
              <div className={styles['publisher']}>{publisher}</div>
              <div className={styles['buttons']} onClick={stopPropagation}>
                {controls}
              </div>
            </LinkArea>
            {publicationDate}
          </div>
        </div>
      </div>
    </article>
  );
}

export const Card = memo(CardComponent);
